import { ModuleTreeState } from '@/store/modules/module-tree/types/module-tree.types';
import { defaultApiState } from '@/store/types/general.types';

export const moduleTreeState: ModuleTreeState = {
  apiState: {
    getModuleTree: defaultApiState
  },
  moduleTree: undefined
};
